import { Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { isEqual, get, isEmpty } from 'lodash-es';

import { Product, SelectedProduct } from '@model/product-detail.model';
import { QuotationService } from '@service/quotation.service';
import { getPriceErrorType, PackageTypeCatagory } from '@enum/quotation.enum';
import { QuoteData } from '@model/quotation.model';
import { CommonService } from '@service/common.service';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductDetailComponent implements OnInit, OnDestroy {
  @Input() productDetailData: Product;
  @Input() errorMessageType: string;
  @Input() currentQuoteData: QuoteData;

  getPriceErrorType: typeof getPriceErrorType = getPriceErrorType;
  selectedProduct: SelectedProduct;
  translateOnChangeSubscription: Subscription;

  public currentLang: string = 'en';
  private defaultCoverageCode: string = 'MLLPD';

  constructor(private translate: TranslateService, private quotationService: QuotationService, private commonService: CommonService) {}

  ngOnInit(): void {
    this.translateOnChangeSubscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLang = event.lang;
    });
  }

  ngOnDestroy(): void {
    this.translateOnChangeSubscription.unsubscribe();
  }

  setInitialSelectedProduct(productDetailData: Product): void {
    this.setSelectedProduct(0, productDetailData);
  }

  changeSelectedProduct(index: number): void {
    this.setSelectedProduct(index, this.productDetailData);
  }

  showTable(): boolean {
    return get(this.productDetailData, 'packages', false) && !isEmpty(this.productDetailData.packages);
  }

  hasCoverageDetail(coverageCode: string): boolean {
    return coverageCode === this.defaultCoverageCode;
  }

  showNotFoundMessage(): boolean {
    return this.errorMessageType === this.getPriceErrorType.NOT_FOUND;
  }

  calculatePrice(price: string): number {
    const productPrice: number = this.commonService.convertCurrencyToNumber(price);

    if (this.currentQuoteData.type.code === PackageTypeCatagory.INDIVIDUAL) {
      return productPrice * parseInt(this.currentQuoteData.numPeople.code, 10);
    } else {
      return productPrice;
    }
  }

  private setSelectedProduct(index: number, productDetailData: Product): void {
    if (get(productDetailData, `packages[${index}]`, false)) {
      this.selectedProduct = {
        index,
        product: productDetailData.packages[index]
      };
      this.quotationService.changeSelectedProduct(this.selectedProduct);
    }
  }
}
